import React, { useState, useContext, useEffect } from "react";
import $ from "jquery";
import PsContext from "../../../context";
import StepOne from "../newRegistration/stepOne";
import StepTwo from "../newRegistration/stepTwo";
import StepThree from "../newRegistration/stepThree";
import ApplicationPreview from "../applicationPreview";
import CourseApply from "../courseApply";
import { Col, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import ApplicationList from "../applicationList";
import { webBannerImage } from "../../../utils";

const Dashboard = (props) => {
  const context = useContext(PsContext);

  if (context.user.registration_completed == "0") return <StepOne {...props} />;
  else if (context.user.certificates_uploaded == "0")
    return <StepThree {...props} />;
  else if (context.user.marks_uploaded == "0") return <StepTwo {...props} />;
  else if (context.user.application_declaration == "0")
    return <ApplicationPreview {...props} />;
  else if (
    context.user.regular_course_applied == "0" &&
    context.user.self_course_applied == "0"
  )
    return <CourseApply {...props} />;

  const quickLinks = [
    {
      text: "Explore Courses",
      subtitle: "Apply for new programmes",
      icon: "fa-solid fa-graduation-cap",
      link: "/apply",
      colorClass: "quick-card-explore",
    },
    {
      text: "Student Profile",
      subtitle: "Manage your information",
      icon: "fa-solid fa-user-graduate",
      link: "/my-profile",
      colorClass: "quick-card-profile",
    },
    {
      text: "Log Out",
      subtitle: "Safe Logout from portal",
      icon: "fa-solid fa-power-off",
      link: "",
      onClick: () => context.logout(),
      colorClass: "quick-card-logout",
    },
  ];

  const getQuickLink = (item) => {
    return (
      <Link
        className={`quick-link-card-modern ${item.colorClass}`}
        to={item.link}
        onClick={() => item.onClick && item.onClick()}
      >
        <div className="quick-link-icon-box">
          <i className={item.icon}></i>
        </div>
        <div className="quick-link-info">
          <span className="quick-link-title text-uppercase font-inter">
            {item.text}
          </span>
          <span className="quick-link-subtitle font-outfit mt-1">
            {item.subtitle}
          </span>
        </div>
        <i className="fa-solid fa-chevron-right fs-12 opacity-50 text-white"></i>
      </Link>
    );
  };

  return (
    <>
      <div
        className="dashboard-hero-breadcrumb"
        style={{ backgroundImage: `url(${webBannerImage()})` }}
      >
        <div className="container-fluid px-4 px-lg-5">
          <div className="dashboard-hero-content">
            <h1 className="dashboard-hero-title font-outfit">
              Welcome, {context.user.name && context.user.name.split(" ")[0]}
            </h1>
            <div className="dashboard-hero-subtitle font-inter">
              <span className="breadcrumb-dash-item">
                <i className="fa-solid fa-house"></i> Admission Portal
              </span>
              <i className="fa-solid fa-chevron-right small opacity-50"></i>
              <span className="breadcrumb-dash-item text-white fw-700">
                Dashboard
              </span>
            </div>
          </div>
        </div>
      </div>

      <div className="container px-4 px-lg-5 my-5">
        <Row className="g-3">
          {quickLinks.map((item, i) => {
            return (
              <Col key={i} md={6} xl={4}>
                {getQuickLink(item)}
              </Col>
            );
          })}
        </Row>

        <Row className="mt-3">
          <Col md={12}>
            <ApplicationList />
          </Col>
        </Row>
      </div>
    </>
  );
};

export default Dashboard;
